import { Component, OnInit } from '@angular/core';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { CommonService } from '@app/shared/services/common/common.service';
import { ReportService } from '@app/shared/services/reports/report.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MessageService } from '@app/shared/services/common/message.service';
import { DashboardService } from '@app/shared/services/dashboard/dashboard.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { EditStoreShopifyPopupComponent } from '@app/feature/store-admin/components/edit-store-shopify-popup/edit-store-shopify-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { WelcomeScreenComponent } from '@app/feature/store-admin/components/welcome-screen/welcome-screen.component';
import { AddProductPopupComponent } from '@app/feature/store-admin/components/add-product-popup/add-product-popup.component';
import { AddressService } from '@app/shared/services/address/address.service';
import { GetProfileInfoInterface } from '@app/shared/services/address/getProfileInfo.interface';
import { APIResponse } from '@app/shared/services/core/ICore.interface';
import { GetStoreInterface } from '@app/shared/services/common/getStoreList.interface';
import { CartService } from '../../../end-user/services/cart/cart.service';
import { GetCartItemsInterface } from '../../../end-user/services/cart/GetCartItems.interface';
import { Router } from '@angular/router';
import { ReleaseLogComponent } from '../../../../shared/components/release-log/release-log.component';
import { ProductService } from '@app/shared/services/product/product.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  showAppTour: boolean;
  HasW9Details = true;
  ShowofflineStore: number = 0;
  IsReleaseViewed: boolean;
  constructor(
    private loader: LoaderService,
    private notificationService: NotificationService,
    public dashboardService: DashboardService,
    public commonService: CommonService,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private errorhandlerService: ErrorhandlerService,
    protected addressService: AddressService,
    private dialog: MatDialog,
    private cartservice: CartService,
    private router: Router,
    private productService: ProductService
  ) {

  }
  storeList: GetStoreInterface[] = [];
  dashboardDivData: any;
  cartItems: GetCartItemsInterface[] = [];
  subscriptionInfo: any = null;



  ngOnInit() {
    this.storeList = [];
    this.dashboardDivData = {};
    this.fn_LoadSubscriptionInfo();
    this.fn_GetDashboardData();
    this.fn_GetCartItems()
    this.fn_getStoreList();
    this.IsReleaseViewed = Boolean(JSON.parse(localStorage.getItem('IsReleasedLogViewed')));
    if (!this.IsReleaseViewed) {
      this.fn_ShowReleaseLog();
    }
    if (localStorage['ShowWelcomeScreen'] == "true" && localStorage['ForceChangePassword'] != "true") {
      this.showWelcomeWindow();
      localStorage.removeItem('ShowWelcomeScreen');
    }
  }

  fn_LoadSubscriptionInfo() {
    try {
      const subInfoStr = localStorage.getItem('subscriptionInfo');
      if (subInfoStr) {
        this.subscriptionInfo = JSON.parse(subInfoStr);
      }
    } catch (e) {
      this.subscriptionInfo = null;
    }
  }

  fn_GetDaysUntilExpiry(): number | null {
    if (!this.subscriptionInfo || !this.subscriptionInfo.ExpiryDate) {
      return null;
    }
    const expiry = new Date(this.subscriptionInfo.ExpiryDate);
    const now = new Date();
    const diffTime = expiry.getTime() - now.getTime();
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  fn_ShowReleaseLog() {
    localStorage.setItem('IsReleasedLogViewed', "true");
    this.dialog.open(ReleaseLogComponent, {
      disableClose: true,
      width: '80%',
      height: '600px'
    });
  }
  fn_GetCartItems() {
    this.loader.show();
    this.cartservice.GetCartItems(localStorage.getItem('userId'), 0).subscribe((res) => {
      if (res.StatusCode === 200) {
        // If there are any items in cart
        if (res.Data.ResponseData.length > 0) {
          this.cartItems = res.Data.ResponseData;
          localStorage.setItem('storeId', res.Data.ResponseData[0].StoreId.toString());
          const r = {
            cartItemCount: this.cartItems.length
          };
          this.messageService.sendCartCount(r);
          this.loader.hide();
        } else { // If there are no items in cart, than set the cart count in header as 0
          this.cartItems = [];
          const r = {
            cartItemCount: 0
          };
          this.messageService.sendCartCount(r);
          this.loader.hide();
        }
      } else {
        this.cartItems = [];
        this.loader.hide();
      }
    }, (error: any) => {
      this.loader.hide();
      this.errorhandlerService.handleError(error);
    });
  }
  showWelcomeWindow() {
    const dialogRef = this.dialog.open(WelcomeScreenComponent);
    dialogRef.afterClosed().subscribe(res => {
    });
  }

  showAddProductWindow() {
    // const dialogRef = this.dialog.open(AddProductPopupComponent);

    // dialogRef.afterClosed().subscribe(res => {

    // });
    
    this.router.navigate(['/store/addproduct']);
  }

  changeAppMode(showApptour: boolean) {
    this.showAppTour = showApptour;
  }
  /** Function to get store list */
  async fn_getStoreList() {
    this.showAppTour = false;
    this.loader.show();
    this.commonService
      .getStoreList('', 0, 0, false, localStorage.getItem('userId'), false)
      .subscribe(
        (res: APIResponse<GetStoreInterface[]>) => {
          if (res.StatusCode === 200 && res.Data.ResponseData != null && res.Data.ResponseData.length > 0) {
            this.storeList = res.Data.ResponseData;
            this.showAppTour = this.storeList.length < 0;
            this.loader.hide();
          }
          else if (res.StatusCode === 204 || res.StatusCode === 404) {
            this.showAppTour = true;
            this.loader.hide();
          }
        },
        (err: any) => {
          this.showAppTour = true;
          this.loader.hide();
          // this.notificationService.error('An error occured', 'Error');
          this.errorhandlerService.handleError(err);
        }
      );
  }

  /** Func to get the dashboard basic data */
  async fn_GetDashboardData() {
    this.loader.show();
    this.dashboardService
      .GetStoreAdminDashboardData(localStorage.getItem('userId'))
      .subscribe((res) => {
        if (res.StatusCode === 200) {          
          this.dashboardDivData = res.Data.ResponseData;
          this.HasW9Details = res.Data.ResponseData.HasW9Details;
          this.ShowofflineStore = this.dashboardDivData.TotalNoOfOnlineStores;          
          this.messageService.setStoreAdminChartData(res.Data.ResponseData);
        }
        this.loader.hide();
      },
        (error: any) => {
          this.loader.hide();
          this.errorhandlerService.handleError(error);
        }
      );
  }



  //earningPerStoreMap(res: any) {
  //  let earningStore = 0;
  //  for (let i = 0; i < res.Data.ResponseData.length; i++) {
  //    earningStore += Number(res.Data.ResponseData[i].CommissionAmount);
  //  }
  //  return earningStore;
  //}

  //async checkMissingParamInProfile() {
  //  try {

  //    this.addressService.getStoreAdminById(Number(localStorage.getItem('userId'))).subscribe((res) => {

  //      const isConnectedToBrainTree = res.Data.ResponseData.brainTreeConfig.IsConnectedToBrainTree;

  //      this.commonService.subShopifyDesign().subscribe((result) => {

  //        if (result.shopify && !isConnectedToBrainTree) {
  //          this.displayAlertConnectToPaypal = true;
  //        }
  //        console.log(result.shopify, isConnectedToBrainTree);

  //      });
  //    });
  //  } catch (e) {
  //    console.error(e);
  //  }
  //}

  updateDecorationTypeTags() {
    this.loader.show();
    this.productService.UpdateDecorationTypeTags().subscribe((res) => {
      this.loader.hide();
      if (res.StatusCode === 200) {
        this.notificationService.success(res.Message, 'Success');
      } else {
        this.notificationService.error(res.Message, 'Error');
      }
    }, (error: any) => {
      this.loader.hide();
      this.errorhandlerService.handleError(error);
    });
  }
}
